import { AccessChangesTable } from './access-changes-table';
import { AccessLogTable } from './access-log-table/AccessLogTable';
import { AccessStatistics } from './access-statistics/AccessStatistics';
import { ApiVolumeGraph } from './api-volume/ApiVolumeGraph';
import { ApplicationOverview } from './application-overview';
import { AppStatusTable } from './application-status';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityViewContainer } from './DataSecurityViewContainer';
import { IncidentLogTable } from './incident-log-table';
import React from 'react';
import { UptimeMonitorsDashboard } from './uptime-monitors-dashboard';
import { useParams } from 'react-router-dom';
import { VerticalColumn } from '@ui/general/VerticalColumn';
export const DataSecurityApplicationOverview = ({ viewParams, onViewChange }) => {
    const { id } = useParams();
    const applicationId = Number(id);
    return (React.createElement(DataSecurityViewContainer, { onViewChange: onViewChange, title: COPY_SPECIFIC.APPLICATION_OVERVIEW, viewParams: viewParams },
        React.createElement(VerticalColumn, null,
            React.createElement(UptimeMonitorsDashboard, { applicationId: applicationId }),
            React.createElement(ApplicationOverview, { applicationId: applicationId }),
            React.createElement(AccessLogTable, { applicationId: applicationId, dateRange: viewParams.dateRange })),
        React.createElement(VerticalColumn, null,
            React.createElement(ApiVolumeGraph, { applicationId: applicationId, viewParams: viewParams }),
            React.createElement(AccessStatistics, { applicationId: applicationId, viewParams: viewParams }),
            React.createElement(AccessChangesTable, { applicationId: applicationId, viewParams: viewParams }),
            React.createElement("div", { className: 'column-row' },
                React.createElement(AppStatusTable, { applicationId: applicationId }),
                React.createElement(IncidentLogTable, { applicationId: applicationId, viewParams: viewParams })))));
};
